import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CardLinkAffiliate } from './models/card-link-affiliate.model';

export interface CardLinkAffiliatesState extends EntityState<CardLinkAffiliate> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'card-link-affiliates', idKey: 'CompanyId'})
export class CardLinkAffiliatesStore extends EntityStore<CardLinkAffiliatesState> {

  constructor() {
    super();
  }

}
